import { Col, Row } from '@portalterreno/react-ui-core/Grid';
import React, { Fragment } from 'react';

import Footer from '../Footer';
import Header from '../Header';
import ContentContainer from './ContentContainer';

const MainLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Fragment>
      <Header />

      <ContentContainer>
        <Row>
          <Col>{children}</Col>
        </Row>
      </ContentContainer>

      <Footer />
    </Fragment>
  );
};

export default MainLayout;
